import styled, {css} from 'styled-components';
import ArrowBack from '../../assets/onboarding/arrow-right.svg';

const BackArrow = styled(ArrowBack as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.1rem'};
  height: ${props => props.height || '1.1rem'};
  display: flex;
  opacity: ${props => props.disabled ? 0.2 : 1};
  pointer-events: ${props => props.disabled ? 'none' : 'auto'};
  cursor: ${props => props.disabled ? 'default' : 'pointer'};
  margin-right: ${props => props.margin || '0.4rem'};
`;

export default BackArrow;
